<template>
  <div class="comp">
    <div class="compContent">
      <div class="title">
        <div class="titleL">编辑医疗服务</div>
        <div class="titleR">
          <el-button type="warning" plain size="small" @click="back">返回</el-button>
        </div>
      </div>
      <div class="content">
        <div class="msg">
          <div class="msgItem">
            <div class="label">顾客名称:</div>
            <div class="value">
              {{ detail.memberName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">手机号:</div>
            <div class="value">
              {{ detail.memberMobile }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">项目:</div>
            <div class="value">
              {{ detail.serviceTypeId == 1 ? "疫苗" : "驱虫" }}
            </div>
          </div>
          <div class="msgItem" style="width: 33%">
            <div class="label">套餐:</div>
            <div class="value">
              {{ detail.medicalServiceName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">宠物昵称:</div>
            <div class="value">
              {{ detail.petName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">品种:</div>
            <div class="value">
              {{ detail.typeName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">年龄:</div>
            <div class="value">
              <span v-if="detail.birthDay">
                {{
                  $public.FAge(new Date(detail.birthDay).getTime())[0] +
                  "岁" +
                  $public.FAge(new Date(detail.birthDay).getTime())[1] +
                  "月"
                }}
              </span>
            </div>
          </div>
          <div class="msgItem">
            <div class="label">性别:</div>
            <div class="value">
              {{ detail.sex }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">创建人:</div>
            <div class="value">
              {{ detail.createUserName }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">创建时间:</div>
            <div class="value">
              {{ $public.FTime(detail.createTime) }}
            </div>
          </div>
          <div class="msgItem">
            <div class="label">支付方式:</div>
            <div class="value">
              <span style="line-height: 32px">全额支付</span>
            </div>
          </div>
        </div>
        <div class="relation">
          <div class="relationTitLine">
            <div style="line-height: 40px">套餐明细</div>
            <div>
              <el-button type="warning" icon="el-icon-plus" size="small" @click="addGoods()">添加药品</el-button>
            </div>
          </div>
          <el-table border :data="detail.serviceGoods" ref="table">
            <el-table-column width="40">
              <template slot-scope="props">
                <el-checkbox v-model="selectedArr[props.$index]" :disabled="!!props.row.orderNum || props.row.canDelete === false
                  " @change="changeTotal(arguments[0], 'selectGoods')"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column label="名称" prop="goodsName" min-width="150">
              <template slot-scope="props">
                {{ props.row.dosageCeiling === 1 ? "[ 整 ] " : "" }}
                {{ props.row.goodsName }}
                <span v-if="props.row.replaceType === 2" style="color: #fdd000">(换)</span>
              </template>
            </el-table-column>
            <el-table-column label="规格" prop="skuValue" min-width="80">
            </el-table-column>
            <el-table-column label="数量" prop="num" min-width="100">
              <template slot-scope="props">
                <el-input :disabled="!!props.row.orderNum || props.row.replaceType == 2" v-model="props.row.num" @blur="
                  $public.isNull(props.row.num) &&
                  changeTotal(arguments[0], 'changeNum', props.row, 'blur')
                  " @input="changeTotal(arguments[0], 'changeNum', props.row)" style="width: 70px">
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="单位" prop="unit" min-width="60">
            </el-table-column>
            <el-table-column label="出库量" min-width="140">
              <template slot-scope="props">
                <div class="cishu">
                  <el-input :disabled="!$public.isNull(props.row.orderNum) ||
                    props.row.replaceType == 2
                    " v-model="props.row.goodsDosage" @blur="
    $public.isNull(props.row.goodsDosage) &&
    changeTotal(
      arguments[0],
      'changeGoodsDosage',
      props.row,
      'blur'
    )
    " @input="
    changeTotal(arguments[0], 'changeGoodsDosage', props.row)
    " style="width: 120px">
                    <template slot="append" style="padding: 0;">{{
                      props.row.outUnit
                    }}</template>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="单价" prop="originalPrice" min-width="60">
            </el-table-column>
            <el-table-column label="换算单位" min-width="90">
              <template slot-scope="props">
                {{ props.row.unit_changesrc }}={{ props.row.unit_changedesc }}
              </template>
            </el-table-column>
            <el-table-column label="库存" min-width="100">
              <template slot-scope="props">
                <span v-if="props.row.skuStocks && props.row.skuStocks.length > 0">
                  {{
                    $public.getMatchingItem(
                      props.row.skuStocks[props.row.skuValueIndex].lstStock,
                      "shopId",
                      curShopId
                    ).stock
                  }}
                  
                </span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column label="支付状态" min-width="70">
              <template slot-scope="props">
                <span v-if="props.row.isPay" style="color: #18a44c">已支付</span>
                <span v-else>
                  <span v-if="props.row.orderNum" style="color: #fdd000">待支付</span>
                  <span v-if="!props.row.orderNum" style="color: red">未支付</span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="小计" min-width="90">
              <template slot-scope="props">
                {{ $public.getSubtotal(props.row) }}
              </template>
            </el-table-column>
            <el-table-column label="是否补差价" min-width="90">
              <template slot-scope="props" v-if="props.row.replaceType === 2">
                <el-switch :disabled="props.row.diffPrice <= 0 ||
                  !$public.isNull(props.row.orderNum)
                  " :value="!props.row.notCount" @change="changeNotCount(arguments[0], props.row)">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" min-width="125">
              <template slot-scope="props">
                <div v-if="props.row.isOut == false">
                  <el-button v-if="props.row.isPay == true &&
                    props.row.replaceType == 0 &&
                    props.row.goodsType == 1
                    " type="success" @click="changeGoods(props.row, props.$index)" size="mini">更换</el-button>
                  <el-button v-if="!props.row.orderNum && props.row.replaceType == 2" type="warning"
                    @click="cancelGoods(props.row)" size="mini">取消更换</el-button>
                  <el-button v-if="!props.row.orderNum &&
                    props.row.replaceType == 0 &&
                    props.row.canDelete
                    " type="danger" @click="deleteGoods(props.row, props.$index)" size="mini">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center; margin: 30px 0 30px">
            <el-button v-if="detail.serviceStatus !== 2" type="success" style="width: 100px" @click="complete"
              size="small">已完成</el-button>
          </div>
          <div style="text-align: center; margin: 30px 0 0; padding-bottom: 30px">
            <span v-if="orderNumber !== ''">
              有未支付订单，
              <span style="color: #32a05b; cursor: pointer" @click="openDialogPay">去支付</span>
              <span style="color: red; cursor: pointer; margin-left: 10px" @click="closeOrder">取消</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="settlement">
      <div class="settlementL">
        <span>共计：</span><span style="font-size: 16px; margin-right: 40px">{{ totalMoney.count }}件</span>
        <span>套餐计划价：</span><span style="font-size: 16px; margin-right: 40px">￥{{ detail.packageMoney }}</span>
        <span>小计：</span><span style="font-size: 16px; margin-right: 40px">￥{{ totalMoney.total }}</span>
        <span style="color: #18a44c">已支付：</span><span style="font-size: 16px; color: #18a44c; margin-right: 40px">￥{{
          totalMoney.paid }}</span>
        <span style="color: red">待支付：</span><span style="font-size: 16px; color: red; margin-right: 50px">
          ￥{{ totalMoney.unpaid }}
        </span>
      </div>
      <div class="settlementR">
        <span>总计：</span><span style="font-size: 16px; margin-right: 20px">￥{{ totalMoney.unpaid }}</span>
        <el-button style="width: 100px" type="warning" plain @click="save" size="small">保存</el-button>
        <el-button style="width: 100px" type="warning" @click="createOrder" size="small">生成订单</el-button>
      </div>
    </div>
    <!-- 添加套餐 -->
    <div v-if="dialogAddGoods_state">
      <dialogAddShop :addShopState="dialogAddGoods_state" :shopId="curShopId" :tree="[
        {
          id: '602f1e88c904d9db7ccf3bec',
          children: [
            { id: '602f1e88c904d9db7ccf3bed' },
            { id: '602f1e89c904d9db7ccf3bf6' },
            { id: '602f1e89c904d9db7ccf3bf8' },
            { id: '602f1e89c904d9db7ccf3bfc' },
            { id: '602f1e89c904d9db7ccf3bff' },
          ],
        },
      ]" @submit="submit_dialogAddGoods" @closeOn="dialogAddGoods_state = false"></dialogAddShop>
    </div>
    <div v-if="dialogChangeGoods_state">
      <dialogChangeGoods :replaceRate="detail.replaceRate" :oldGoods="propsRow" :posi="[0, propsId]"
        @submit="submitChangeGoods"></dialogChangeGoods>
    </div>
    <div v-if="dialogShouyin_state">
      <dialogShouyin :type="2" :bingliMsg="detail" :delPaid="totalMoney.delPaid" :selectedArr="shouyinData"
        @submit="submit_shouyin" @close="dialogShouyin_state = false"></dialogShouyin>
    </div>
    <div v-if="dialogPay_state">
      <dialogQRCode :QRCode="codeUrl" :orderNum="orderNumber" @submit="submit_dialog_pay"></dialogQRCode>
    </div>
    <div v-if="dialogComplete_state">
      <dialogComplete :id="detail.id" :type="'ylfw'" @submit="submit_dialog_complete"></dialogComplete>
    </div>
    <!-- 选择支付方式 医疗-->
    <div v-if="yiliao_state">
      <dialogYiLiao :orderNum="orderNumber" @submit="submityiLiao"></dialogYiLiao>
    </div>
  </div>
</template>
<script>
import dialogAddShop from "../../../../components/dialog_addShop.vue";
import dialogYiLiao from "../../../../components/dialog_yiliao.vue";
import dialogChangeGoods from "../../../../components/dialogChangeGoods.vue";
import dialogShouyin from "../../../../components/dialogShouyin.vue";
import dialogQRCode from "../../../../components/dialogQRCode.vue";
import dialogComplete from "../../../../components/dialog_complete.vue";
export default {
  components: {
    dialogAddShop,
    dialogChangeGoods,
    dialogShouyin,
    dialogQRCode,
    dialogComplete,
    dialogYiLiao,
  },
  data() {
    return {
      yiliao_state: false,
      dialogShouyin_state: false,
      shouyinData: [],

      dialogAddGoods_state: false,
      dialogPay_state: false,
      orderNumber: "",
      codeUrl: "",
      dialogChangeGoods_state: false,
      dialogComplete_state: false,

      propsId: "",
      propsRow: "",

      detail: {},

      selectedArr: [],

      totalMoney: {},
    };
  },
  computed: {
    curShopId() {
      return this.$store.state.shopId;
    },
    ylfwParams() {
      return this.$store.state.yiliaoxin.ylfwParams;
    },
  },
  mounted() {
    this.getDetail("mounted");
  },
  methods: {
    // 关闭医疗支付弹框
    submityiLiao() {
      this.yiliao_state = false;
    },
    // 返回
    back() {
      this.$store.commit("yiliaoxin/remove_router");
      if (this.$store.state.yiliaoxin.router.length === 0) {
        this.ylfwParams.type = "list";
        this.$store.commit("yiliaoxin/set_ylfwParams", this.ylfwParams);
        this.$store.commit("yiliaoxin/set_curBusiness", "医疗服务");
      }
      // if(
      // 	this.$store.state.yiliaoxin.curBusinessPre==='工作台'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rBingli'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rYmqc'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rZhuyuan'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenDai'||
      // 	this.$store.state.yiliaoxin.curBusinessPre==='rJiezhenZhong'
      // ){
      // 	this.$store.commit('yiliaoxin/set_curBusiness',this.$store.state.yiliaoxin.curBusinessPre)
      // 	return
      // }
      // this.ylfwParams.type = 'list'
      // this.$store.commit("yiliaoxin/set_ylfwParams",this.ylfwParams)
    },
    changeTotal(e, str, row, type) {
      if (str == "selectGoods") {
        this.getTotal();
      } else if (str == "changeNum") {
        if (type == "blur" && row.num === "") row.num = 1;
        row.num = this.$public.replaceGoodsDosage(row.num);
        if (row.goodsType === 1) {
          let stock = this.$public.getMatchingItem(
            row.skuStocks[row.skuValueIndex].lstStock,
            "shopId",
            this.curShopId
          ).stock;
          let totalTimes = this.$public.getMatchingItem(
            row.skuStocks[row.skuValueIndex].lstStock,
            "shopId",
            this.curShopId
          ).totalTimes;
          if (row.num > stock) {
            this.$message({
              message: "该药品最大数量为" + stock,
              type: "error",
            });
            row.num = stock;
          }
          let goodsDosage = this.$public.cheng(row.num, row.in_exchanage);
          if (goodsDosage > totalTimes) {
            row.goodsDosage = totalTimes;
          } else {
            row.goodsDosage = goodsDosage;
          }
        }
        if (row.num !== "") {
          let params = {
            itemsId: row.itemsId,
            num: Number(row.num),
            allowWholesale: row.allow_wholesale,
            goodsDosage: Number(row.goodsDosage),
          };
          this.$http
            .post("/api/MedicalService/UpdateNum", params)
            .then((res) => {
              if (res.code == 0) {
                console.log("修改数量成功");
              }
              this.getDetail();
            });
        }
      } else if (str == "chajia") {
        this.getTotal();
      } else if (str == "changeGoodsDosage") {
        console.log(row,'rowrowrow');
        row.goodsDosage = this.$public.replaceGoodsDosage(row.goodsDosage);
        console.log(row,'rowrowrow1');
        let totalTimes = this.$public.getMatchingItem(
          row.skuStocks[row.skuValueIndex].lstStock,
          "shopId",
          this.curShopId
        ).totalTimes;
        console.log(row,'rowrowrow2');
        if (row.goodsDosage > totalTimes) {
          this.$message({
            message: "该药品最大用量为" + totalTimes,
            type: "error",
          });
          row.goodsDosage = totalTimes;
        }
        console.log(row,'rowrowrow3');
        let num = Math.ceil(
          this.$public.chu(Number(row.goodsDosage), row.in_exchanage)
        );
        row.num = num;
        if (type == "blur" && row.goodsDosage === "") row.goodsDosage = 1;
        if (row.goodsDosage !== "") {
          let params = {
            itemsId: row.itemsId,
            num: Number(row.num),
            allowWholesale: row.allow_wholesale,
            goodsDosage: Number(row.goodsDosage),
          };
          this.$http
            .post("/api/MedicalService/UpdateNum", params)
            .then((res) => {
              if (res.code == 0) {
                console.log("修改用量成功");
              }
              this.getDetail();
            });
        }
      }
    },
    // 计算总价
    getTotal() {
      let total = { delPaid: 0, paid: 0, unpaid: 0, total: 0, count: 0 };
      for (let a = 0; a < this.selectedArr.length; a++) {
        let goods = this.detail.serviceGoods[a];
        let N = goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
        if (this.selectedArr[a]) {
          // 选中的计划
          if (goods === undefined) {
            this.selectedArr.splice(a, 1);
          } else {
            total.count = total.count + 1;
            total.total = this.$public.jia(
              total.total,
              this.$public.cheng(N, goods.price)
            );
          }
        }
      }

      let replaceObj = {};
      for (let c = 0; c < this.detail.serviceGoodsAll.length; c++) {
        let goods = this.detail.serviceGoodsAll[c];
        let N = goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
        if (goods.replaceType === 0 && goods.isPay !== true) {
          // replaceType===0 并且 未支付的金额
          total.unpaid = this.$public.jia(
            total.unpaid,
            this.$public.cheng(N, goods.price)
          );
        }
        if (goods.isPay === true) {
          // 已支付
          if (goods.replaceType === 0) {
            //  没有进行替换的
            total.paid = this.$public.jia(
              total.paid,
              this.$public.cheng(N, goods.price)
            );
          } else if (goods.replaceType === 1) {
            if (goods.notCount == false) {
              total.paid = this.$public.jia(
                total.paid,
                this.$public.cheng(N, goods.price)
              );
            } else {
              var findItems = this.detail.serviceGoodsAll.find((m) => {
                return m.replaceMark === goods.id && m.isPay === true;
              });
              if (findItems === undefined) {
                total.paid = this.$public.jia(
                  total.paid,
                  this.$public.cheng(N, goods.price)
                );
              }
            }
          } else if (goods.replaceType === 2) {
            if (goods.notCount === false) {
              total.paid = this.$public.jia(
                total.paid,
                this.$public.cheng(N, goods.price)
              );
            }
          }
        }
        if (!this.$public.isNull(goods.replaceMark) && goods.isPay !== true) {
          if (replaceObj[goods.replaceMark] == undefined) {
            replaceObj[goods.replaceMark] = [0, 0];
            replaceObj[goods.replaceMark][1] = this.$public.cheng(
              goods.price,
              N
            );
          } else {
            replaceObj[goods.replaceMark][1] = this.$public.jia(
              replaceObj[goods.replaceMark][1],
              this.$public.cheng(goods.price, N) < 0
                ? 0
                : this.$public.cheng(goods.price, N)
            );
          }
        }
      }
      for (let k in replaceObj) {
        let goods = this.detail.serviceGoodsAll.find((item) => {
          return item.id === k;
        }); // 被替换的商品
        let N = goods.allowWholesale === 0 ? goods.countPriceDosage : goods.num;
        replaceObj[k][0] = this.$public.cheng(goods.price, N);
        replaceObj[k][2] = goods.notCount;
        if (replaceObj[k][2] === true) {
          // 补差价
          total.unpaid = this.$public.jia(
            total.unpaid,
            this.$public.jian(replaceObj[k][1], replaceObj[k][0])
          );
          total.delPaid = this.$public.jia(total.delPaid, replaceObj[k][0]);
        }
      }
      this.totalMoney = total;
    },
    // 无用的保存
    save() {
      this.$message({
        message: " 保存成功",
        type: "success",
      });
    },
    // 生成订单
    createOrder() {
      this.shouyinData = [];
      for (let a = 0; a < this.selectedArr.length; a++) {
        if (this.selectedArr[a]) {
          let goods = this.detail.serviceGoods[a];
          if (!goods.isPay && goods.orderNum) {
            this.$message({
              message: "当前页面有未支付的商品，不可再次生成订单",
              type: "error",
            });
            return;
          }
          if (!goods.orderNum) {
            this.shouyinData.push(goods);
          }
        }
      }
      if (this.shouyinData.length == 0) {
        this.$message({
          message: "当前页面内没有要结算的项目",
          type: "error",
        });
        return;
      } else {
        for (let i = 0; i < this.shouyinData.length; i++) {
          let goods = this.shouyinData[i];
          if (!goods.orderNum) {
            if (goods.skuValueIndex !== undefined && goods.goodsType === 1) {
              let stock = this.$public.getMatchingItem(
                goods.skuStocks[goods.skuValueIndex].lstStock,
                "shopId",
                this.curShopId
              ).stock;
              if (stock == 0) {
                this.$confirm(
                  goods.goodsName + " 已没有库存,确定要生成订单",
                  "警告",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                ).then(() => {
                  this.dialogShouyin_state = true;
                });
                return;
              } else if (stock < goods.num) {
                this.$confirm(
                  goods.goodsName + " 库存不足,确定要生成订单",
                  "警告",
                  {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  }
                ).then(() => {
                  this.dialogShouyin_state = true;
                });
                return;
              }
            }
          }
        }
        this.dialogShouyin_state = true;
      }
    },
    // 收银
    submit_shouyin() {
      this.dialogShouyin_state = false;
      this.getDetail("mounted");
    },
    addGoods() {
      this.propsRow = "";
      this.dialogAddGoods_state = true;
    },
    submit_dialogAddGoods({ goodsItem, skuItem, wayItem, goodsType }) {
      console.log(goodsItem, "goodsItemgoodsItemgoodsItemgoodsItemgoodsItem");
      let row = this.$public.getRow(goodsItem, skuItem, wayItem, goodsType);
      let table = this.detail.serviceGoods;
      for (let i = 0; i < table.length; i++) {
        if (
          this.$public.isNull(table[i].orderNum) &&
          [i].skus == row.skus &&
          [i].goodsId == row.goodsId
        ) {
          this.$message({
            message: "该商品已添加",
            type: "error",
          });
          return;
        }
      }
      if (row.stock == 0) {
        this.$message({
          message: "该商品已没有库存，请及时申请采购",
          type: "error",
        });
        return;
      }
      let params = {
        serviceId: this.detail.id,
        serviceGoods: [
          {
            brand: row.brand,
            categoryId: row.categoryId,
            categoryName: row.categoryName,
            allowWholesale: row.allow_wholesale,
            outUnit: row.outUnit,
            goodsId: row.goodsId,
            goodsName: row.goodsName,
            otherName: row.otherName, // 别名
            isHumanMedication: row.isHumanMedication,
            goodsType: row.goodsType,
            skus: row.skus,
            skuValue: row.skuValue,
            model: row.model,
            unit: row.unit,
            originalPrice: row.originalPrice,
            price: row.price,
            num: row.num,
            activityId: "",
            activityName: "",
            totalMoney: this.$public.cheng(row.num, row.price),
            goodsUsage: "",
            goodsDosage: row.goodsDosage,
            dosageCeiling: Number(row.dosageCeiling), // 向上取整
            dosageCeilingValue: Number(row.dosageCeilingValue), // 向上取整
            goodsTimes: "",
            remark: row.remark,
            extendContent: row.extendContent,
          },
        ],
      };
      let loading = this.$loading();
      this.$http.post("/api/MedicalService/AddGoods", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.$message({
            message: "添加成功",
            type: "success",
          });
          this.getDetail();
        }
      });
    },
    // 获取详情
    getDetail(str) {
      this.$http
        .get("/api/MedicalService/Detail", { id: this.ylfwParams.curRow.id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.serviceGoods == null) {
              res.data.serviceGoods = [];
              this.selectedArr = [];
            }
            res.data.serviceGoodsAll = res.data.serviceGoods;
            res.data.serviceGoods = this.filterPlanGoods(res.data.serviceGoods);
            if (str == "mounted") {
              this.selectedArr = [];
              for (let i = 0; i < res.data.serviceGoods.length; i++) {
                this.selectedArr.push(true);
              }
            } else {
              for (let i = 0; i < res.data.serviceGoods.length; i++) {
                if (this.selectedArr[i] === undefined) {
                  this.selectedArr.push(true);
                }
              }
            }
            let arr = [];
            for (let i = 0; i < res.data.serviceGoods.length; i++) {
              arr.push(res.data.serviceGoods[i]);
            }
            let ArrC=arr.filter((item)=>{
              return item.goodsType===1;
            });
            console.log(arr,'arr[i]');
            if(ArrC){
              this.$util.getGoodsInfo(ArrC).then((goodsList) => {
              for (let i = 0; i < goodsList.length; i++) {
                goodsList[i].allow_wholesale = goodsList[i].allowWholesale;
                this.$set(goodsList[i], "skuValueIndex", 0);
                goodsList[i].skuStocks = goodsList[i].skuStocks || [];
                for (let a = 0; a < goodsList[i].skuStocks.length; a++) {
                  if (
                    goodsList[i].skuValue == goodsList[i].skuStocks[a].skuValue
                  ) {
                    this.$set(goodsList[i], "skuValueIndex", a);
                    // this.$set(goodsList[i],'originalPrice',goodsList[i].skuStocks[a].salePrice)
                    this.$set(
                      goodsList[i],
                      "skus",
                      goodsList[i].skuStocks[a].skus
                    );
                    this.$set(
                      goodsList[i],
                      "skuValue",
                      goodsList[i].skuStocks[a].skuValue
                    );
                  }
                }
              }
        
            });
            }
            this.detail = res.data;
              this.$nextTick(() => {
                this.getTotal();
              });
              this.getPayAddr(this.detail.id);
          }
        });
    },
    openDialogPay() {
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: this.detail.id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getDetail();
              return;
            } else {
              if (res.data[0].totalMoney === 0) {
                this.$message({
                  message: "待支付金额为0，请联系前台进行支付",
                  type: "error",
                });
              } else {
                this.yiliao_state = true;
                // this.$http.get('/api/Pay/GotoPay', {orderNum:this.orderNumber}).then(res1 => {
                // 	if (res1.code == 0) {
                // 		this.codeUrl = res1.data.codeUrl
                // 		this.dialogPay_state=true;
                // 	}
                // })
                // this.$http.get('/api/Pay/ScanPayOrder', {orderNum:this.orderNumber}).then(res1 => {
                // 	if (res1.code == 0) {
                // 		this.codeUrl = res1.data.codeUrl
                // 		this.$http.get('/api/Pay/JL/ScanPayOrder', {orderNum:this.orderNumber}).then(res1 => {
                // 			if (res1.code == 0) {
                // 				this.codeUrl_jialian = res1.data.codeUrl
                // 				this.dialogPay_state=true;
                // 			}
                // 		})
                // 	}
                // })
              }
            }
          }
        });
    },
    closeOrder() {
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: this.detail.id })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length === 0) {
              this.$message({
                message: "该订单已支付或已取消",
                type: "success",
              });
              this.getDetail();
              return;
            } else {
              this.$confirm("确定要取消已生成的订单?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }).then(() => {
                this.$http
                  .get("/api/Order/ReceivedOrder", {
                    order_id: this.orderNumber,
                  })
                  .then((res) => {
                    if (res.code == 0) {
                      this.$message({
                        message: "取消成功",
                        type: "success",
                      });
                      this.getDetail();
                    }
                  });
              });
            }
          }
        });
    },
    submit_dialog_pay() {
      this.dialogPay_state = false;
      this.getDetail();
    },
    // 获取支付地址
    getPayAddr(serviceId) {
      this.orderNumber = "";
      this.$http
        .get("/api/Order/GetServiceOrder", { serviceId: serviceId })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.length > 0) {
              this.orderNumber = res.data[0].orderNumber;
            }
          }
        });
    },
    // 过滤
    filterPlanGoods(arr) {
      let arr1 = [];
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].replaceType !== 1) {
          // 有更换的商品
          arr1.push(arr[i]);
        }
      }
      return arr1;
    },
    // 更换商品
    changeGoods(row, propsIndex) {
      this.propsId = propsIndex;
      this.propsRow = row;
      this.dialogChangeGoods_state = true;
    },
    // 更换商品
    submitChangeGoods(obj) {
      this.dialogChangeGoods_state = false;
      if (obj.type == "close") return;
      if (obj.type == "cancel") return;
      let params = {
        serviceId: this.detail.id,
        beforeGoods: obj.beforeGoods,
        afterGoods: obj.afterGoods,
      };
      let loading = this.$loading();
      this.$http.post("/api/MedicalService/Replace", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.$message({
            message: "更换成功",
            type: "success",
          });
          this.getDetail();
        }
      });
    },
    // 取消更换
    cancelGoods(row) {
      this.$confirm("确定取消更换?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          itemsId: row.itemsId,
        };
        let loading = this.$loading();
        this.$http
          .get("/api/MedicalService/CancelReplace", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                message: "取消成功",
                type: "success",
              });
              this.getDetail();
            }
          });
      });
    },
    // 是否补差价
    changeNotCount(b, row) {
      this.$http
        .get("/api/MedicalService/ChangeNotCount", {
          replaceMark: row.replaceMark,
          notCount: !b,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.getDetail();
          }
        });
    },
    // 删除商品
    deleteGoods(row, index) {
      this.$confirm("确定要删除该商品?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .delete("/api/MedicalService/DeleteGoods", {
            serviceId: this.detail.id,
            goodsItemsId: row.itemsId,
          })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getDetail();
              this.selectedArr.splice(index, 1);
            }
          });
      });
    },
    // 已完成
    complete() {
      if (
        this.detail.serviceGoodsAll.find((item) => {
          return item.isPay === false;
        })
      ) {
        this.$message({
          message: "本页面存在未结算的商品，请前往结算",
          type: "error",
        });
        return;
      }
      this.dialogComplete_state = true;
    },
    submit_dialog_complete(str) {
      this.dialogComplete_state = false;
      if (str === "success") {
        this.getDetail();
        this.$router.replace({
          path: "/yiliaoxin/platform",
          query: { id: this.$route.query.id },
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.comp {
  position: relative;
  height: 100%;
  padding-bottom: 68px;
  box-sizing: border-box;

  .compContent {
    height: 100%;
    background-color: #fff;
    border-radius: 12px;
    overflow: auto;

    .title {
      display: flex;
      height: 47px;
      line-height: 27px;
      border-bottom: 1px solid #f2f2f2;
      padding: 10px 18px;
      box-sizing: border-box;

      .titleL {
        width: 50%;
        font-size: 14px;
        font-weight: bold;
      }

      .titleR {
        width: 50%;
        text-align: right;

        .titleRText {
          display: inline-block;
          font-size: 14px;
          color: $mainColor;
          margin-left: 40px;
          cursor: pointer;
        }
      }
    }

    .content {
      height: calc(100% - 47px);
      overflow: auto;

      .msg {
        display: flex;
        flex-wrap: wrap;
        padding-top: 10px;

        .msgItem {
          width: 22%;
          display: flex;
          padding: 5px 0;

          .label {
            font-size: 14px;
            color: $fontColor;
            width: 100px;
            text-align: right;
            line-height: 32px;
            margin-right: 4px;
          }

          .value {
            font-size: 14px;
            color: $fontColor;
            line-height: 32px;
          }
        }
      }

      .relation {
        padding: 10px 0 8px;

        .relationTitLine {
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          color: $fontColor;
          padding: 0 18px 10px;
          font-weight: bold;
        }

        height: calc(100% - 140px);
      }
    }
  }

  .settlement {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 56px;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    display: flex;
    padding: 12px 20px;
    box-sizing: border-box;

    .settlementL {
      width: 70%;
      font-size: 14px;
      line-height: 32px;
    }

    .settlementR {
      width: 30%;
      text-align: right;
      font-size: 14px;
      line-height: 32px;

      .text {
        color: $fontColor;
        font-size: 14px;
        padding: 0px 24px 0;
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}
</style>
